export type MaskOptions = {
  /**
   * If true, mask will be applied to empty characters
   */
  readonly maskEmpties?: boolean
  /**
   *  Mask pattern char, used to identify characters that should be masked
   */
  readonly maskPatternChar?: string
  /**
   * Mask char, used to replace characters that should be masked
   */
  readonly maskChar?: string
};

export const maskOptionsDefault: MaskOptions = {
  maskEmpties: false,
  maskPatternChar: '*',
  maskChar: '*',
};

/**
 * Mask text based on mask pattern
 * @param text - text to mask
 * @param mask - mask pattern
 * @param options - additional options
 * @returns masked text
 */
export function mask(text: string, maskPatter: string, options: MaskOptions = {}) {
  // extend maskOptionsDefault with options
  const { maskEmpties, maskPatternChar, maskChar } = { ...maskOptionsDefault, ...options };
  const result = [];

  // eslint-disable-next-line no-plusplus
  for (let idx = 0; idx < text.length; idx++) {
    // need mask symbol
    if (maskPatter[idx] === maskPatternChar) {
      const char = text[idx];
      const isEmtyChar = char === ' ';

      if (isEmtyChar && !maskEmpties) {
        // no mask symbol
        result.push(char);
      } else {
        // mask symbol
        result.push(maskChar);
      }
    } else {
      // no mask symbol
      result.push(text[idx]);
    }
  }
  return result.join('');
}
